// extracted by mini-css-extract-plugin
module.exports = {"card":"specialists-card_card__6QidW","imageWrap":"specialists-card_imageWrap__9dvZe","content":"specialists-card_content__8nITa","title":"specialists-card_title__uTf__"};